import React, { FunctionComponent } from "react"
import { Controller } from "react-hook-form"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Textarea from "../../../components/Form/Inputs/Textarea"
import Upload from "../../../components/Upload/Upload"
import { iUser } from "../../../definitions/User"

interface iProps {
  item: iUser
}

const ProfileOverview: FunctionComponent<iProps> = ({ item }) => {
  return (
    <div className="scrollable container">
      <div className="row">
        <div className="col-6">
          <div className="row">
            <div className="col-6">
              <FormInput name="profile.firstName" label="First name" />
            </div>
            <div className="col-6">
              <FormInput name="profile.lastName" label="Last name" />
            </div>
          </div>
          <FormInput name="emails.0.address" label="Email" />
          <FormInput name="profile.country" label="Country" />
          <FormInput name="profile.phone" label="Phone number" />
          <Controller
            render={({ value, onChange }) => (
              <Textarea
                name="profile.bio"
                label="Bio"
                value={value}
                onChange={onChange}
              />
            )}
            name="profile.bio"
          />
        </div>
        <div className="col-6">
          <Upload
            name="profile.image"
            label="Profile image"
            initialFiles={[item?.profile?.imageId || ""]}
            maxFiles={1}
            fileCollection="Files_ProfilePictures"
            fileType={["image/png", "image/jpeg"]}
          />
        </div>
      </div>
    </div>
  )
}

export default ProfileOverview
